module.exports = __webpack_public_path__ + "img/20200908_212759.7d8e105b.jpg";